import { render, staticRenderFns } from "./EmailTemplateConfig.vue?vue&type=template&id=840f5676"
import script from "./EmailTemplateConfig.vue?vue&type=script&lang=js"
export * from "./EmailTemplateConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('840f5676')) {
      api.createRecord('840f5676', component.options)
    } else {
      api.reload('840f5676', component.options)
    }
    module.hot.accept("./EmailTemplateConfig.vue?vue&type=template&id=840f5676", function () {
      api.rerender('840f5676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/EmailTemplateConfig.vue"
export default component.exports